export enum LogLevel {
  NONE = 0,
  ERRORS = 1,
  WARNS = 2,
  INFO = 3,
  DEBUG = 4,
}
